// extracted by mini-css-extract-plugin
export var option = "_bg-0";
export var optionCard = "_bg-f";
export var optionContent = "_bg-g";
export var optionIcon = "_bg-i";
export var optionIconBox = "_bg-h";
export var optionLabel = "_bg-j";
export var optionPill = "_bg-m";
export var optionPillBadge = "_bg-p";
export var optionPillIcon = "_bg-n";
export var optionPillLabel = "_bg-o";
export var optionRadio = "_bg-k";
export var optionRadioInner = "_bg-l";
export var optionReveal = "_bg-2";
export var optionRevealDelay0 = "_bg-3";
export var optionRevealDelay1 = "_bg-4";
export var optionRevealDelay10 = "_bg-d";
export var optionRevealDelay11 = "_bg-e";
export var optionRevealDelay2 = "_bg-5";
export var optionRevealDelay3 = "_bg-6";
export var optionRevealDelay4 = "_bg-7";
export var optionRevealDelay5 = "_bg-8";
export var optionRevealDelay6 = "_bg-9";
export var optionRevealDelay7 = "_bg-a";
export var optionRevealDelay8 = "_bg-b";
export var optionRevealDelay9 = "_bg-c";
export var optionSelected = "_bg-1";